<div class="component-wrapper">
  <div class="title-arrow">
    <div class="title-holder">
      <p class="title">Filtering and visualisation system</p>
      <p class="sub-title">designed for precise performance analysis.</p>
    </div>

    <svg
      class="arrow"
      [ngClass]="{ rotate: isFilterContainerOpen }"
      (click)="onClick()"
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="14.5"
        cy="14.5"
        r="14.5"
        transform="rotate(-180 14.5 14.5)"
        fill="#503291"
      />
      <path
        d="M20.2119 13.1819L14.4998 18.4546L8.78767 13.1819"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>

  <div class="filters-wrapper" *ngIf="state">
    <div class="calendar-select-wrapper">
      <div class="select-wrapper">
        <div class="select">
          <fd-select
            *ngFor="let select of selectConfiguration"
            (valueSelect)="callAddChipMethod($event)"
            [type]="select.type"
            [placeholder]="select.placeholder"
            [options]="select.options"
          >
          </fd-select>
          <div class="filter-button-wrapper">
            <button mat-flat-button (click)="emitFilterRequestModel()">
              Filter
            </button>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isFilterContainerOpen" class="chip-collection-wrapper">
      <fd-chip-collection
        *ngFor="let select of selectConfiguration"
        [type]="select.type"
        [backgroundColor]="select.chipColor"
        (removeChipOutput)="removeChip($event)"
      >
      </fd-chip-collection>
    </div>

    <div class="explanation-holder">
      <ul>
        <li>
          <p>
            Country Selection – Choose one or multiple countries to narrow down
            the dataset and focus on specific geographic regions.
          </p>
        </li>
        <li>
          <p>
            Solution Definition – Select relevant solutions to refine the
            analysis based on your specific criteria.
          </p>
        </li>
      </ul>
      <p>
        The system dynamically processes and displays data on the interactive
        world map, enabling real-time performance tracking and comparative
        analysis across countries and solution categories.
      </p>
    </div>
  </div>
</div>
